import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  return <section className="py-16 px-4 md:px-8 bg-orange-50" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A1A1A] mb-12" data-id="element-42">
            Regalos que se olvidan vs. recuerdos que duran para siempre
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-43">
            <div className="bg-gray-100 rounded-lg p-8 border-2 border-gray-300" data-id="element-44">
              <h3 className="text-2xl font-bold text-gray-700 mb-6 text-center" data-id="element-45">
                Lo que se regala siempre ❌
              </h3>
              <ul className="space-y-4" data-id="element-46">
                <li className="flex items-start gap-3" data-id="element-47">
                  <span className="text-red-500 font-bold" data-id="element-48">❌</span>
                  <span className="text-gray-700" data-id="element-49">Ropa que no usa</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-50">
                  <span className="text-red-500 font-bold" data-id="element-51">❌</span>
                  <span className="text-gray-700" data-id="element-52">Perfume que se acaba</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-53">
                  <span className="text-red-500 font-bold" data-id="element-54">❌</span>
                  <span className="text-gray-700" data-id="element-55">Cena que se olvida</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-56">
                  <span className="text-red-500 font-bold" data-id="element-57">❌</span>
                  <span className="text-gray-700" data-id="element-58">Flores que se secan</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-59">
                  <span className="text-red-500 font-bold" data-id="element-60">❌</span>
                  <span className="text-gray-700" data-id="element-61">
                    Sin valor sentimental real
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-yellow-50 rounded-lg p-8 border-4 border-[#F5A623] shadow-xl" data-id="element-62">
              <h3 className="text-2xl font-bold text-[#1A1A1A] mb-6 text-center" data-id="element-63">
                Cuéntame Tu Historia ✅
              </h3>
              <ul className="space-y-4" data-id="element-64">
                <li className="flex items-start gap-3" data-id="element-65">
                  <span className="text-[#2E7D32] font-bold" data-id="element-66">✅</span>
                  <span className="text-gray-800 font-semibold" data-id="element-67">
                    Su historia guardada para siempre
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-68">
                  <span className="text-[#2E7D32] font-bold" data-id="element-69">✅</span>
                  <span className="text-gray-800 font-semibold" data-id="element-70">
                    Su voz en palabras propias
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-71">
                  <span className="text-[#2E7D32] font-bold" data-id="element-72">✅</span>
                  <span className="text-gray-800 font-semibold" data-id="element-73">
                    Un legado para tus hijos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-74">
                  <span className="text-[#2E7D32] font-bold" data-id="element-75">✅</span>
                  <span className="text-gray-800 font-semibold" data-id="element-76">
                    Conversaciones profundas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-77">
                  <span className="text-[#2E7D32] font-bold" data-id="element-78">✅</span>
                  <span className="text-gray-800 font-semibold" data-id="element-79">
                    El regalo más valioso de su vida
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}